define('uikit/extra/scrollbar.calculate',['require','exports','module'],function(require, exports, module){

  module.exports = {
    width: function() { 
      var inner = document.createElement('div');
      inner.style.width = "100%";
      inner.style.height = "200px";

      var outer = document.createElement('div');
      outer.style.position = "absolute";
      outer.style.top = "0px";
      outer.style.left = "0px";
      outer.style.visibility = "hidden";
      outer.style.width = "200px";
      outer.style.height = "150px";
      outer.style.overflow = "hidden";
      outer.appendChild(inner);

      document.body.appendChild(outer);
      var w1 = $(outer).innerWidth();
      outer.style.overflowY = 'scroll';
      var w2 = $(outer).innerWidth();
      if (w1 == w2) { w2 = outer.clientWidth; }

      document.body.removeChild(outer);

      return (w1 - w2);
    }
  };
});
